import request from '@/libs/request'


// 详情
export function Info (data) {
  return request({
    url: `about/getSting`,
    method: 'get',
    params: data
  })
}

// 添加
export function edit(data) {
  return request({
    url: `about/getStingEdit`,
    method: 'post',
    data: data
  })
}



